import axios from 'axios'
let baseURL = '/offer-api'
const api = axios.create({
  baseURL,
  withCredentials: true,
  headers: {
    'X-Requested-With': 'XMLHttpRequest',
    token: localStorage.getItem('token') || '',
    post: {
      'Content-Type': 'application/json'
    }
  },
  timeout: 60000,
  validateStatus: function(status) {
    return status > 0
  }
})
api.interceptors.request.use(config => {
  config.headers.Dtool = true
  config.params = Object.assign(config.params || {}, { nonce: Date.now() })
  let nonce = window.localStorage.getItem('X-Request-Nonce')
  if (nonce) {
    config.headers = {
      'X-Request-Nonce': nonce
    }
  }
  let csrf = sessionStorage.getItem('X-Request-Csrf')
  if (csrf) {
    config.headers['X-Request-Csrf'] = csrf
  }
  config.headers['X-Frame-Options'] = 'ALLOW-FROM https://payapp.weixin.qq.com'
  let timestamp = new Date().getTime()
  let path = `${location.pathname}?lpo_platform=promotion&timestamp=${timestamp}`
  config.headers['Current-Path'] = `${path}${location.hash}`
  return config
})
api.interceptors.response.use(
  r => {
    r.headers['X-Frame-Options'] = 'ALLOW-FROM https://payapp.weixin.qq.com'
    let csrf = r.headers['X-Request-Csrf'] || r.headers['x-request-csrf']
    if (csrf) {
      sessionStorage.setItem('X-Request-Csrf', csrf)
    }
    const { data, statusCode, message } = r.data
    if (statusCode === 200) {
      return data
    } else {
      if (statusCode === 300 && location.hash.indexOf('#/paymentSuccess') < 0 && process.env.NODE_ENV === 'production') {
        let { hash } = location
        if (hash !== '#/?noRedirect') {
          window.location.replace(encodeURI(message))
        }
      }
      return Promise.reject({ data, statusCode, message })
    }
  },
  error => {
    console.log(error)
    return Promise.reject(error)
  }
)
export default api
